import { KeyValuePair } from "../../../../../utils/sys/KeyValuePair";
import { CharacterData } from "../../../../../utils/game/character/CharacterData";

import FlexColumn from "../../../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../../../common/components/layout/Flexbox/FlexRow";
import MultiLineTextField from "../../../../../common/components/input/MultiLineTextInputToggleField/MultiLineTextInputToggleField";
import TabControl from "../../../../../common/components/layout/TabControl/TabControl";
import { useWindowDimensions } from "../../../../../common/utilities/WindowDimensions";

import { useMemo, useState } from "react";

type Props = {
    characterData: CharacterData;
    isEditable?: boolean;
    selectedTab?: string | null;
    onSelectedTabChanged?: (tab: string | null) => void;
    onCharacterDataValueChanged?: (val: KeyValuePair[]) => void;
};

export default function CharacterSheetNotesTab(props: Props): JSX.Element {
    const [selectedNotesTab, setSelectedNotesTab] = useState<string | null>(
        props.selectedTab ?? null
    );

    const windowDimensions = useWindowDimensions();

    const notesLines = useMemo(
        () => (windowDimensions.width >= 1100 ? 24 : undefined),
        [windowDimensions.width]
    );

    return (
        <FlexColumn>
            <TabControl
                id="notes_tab_control"
                selectedTab={selectedNotesTab}
                onSelectedTabChange={(tab) => {
                    setSelectedNotesTab(() => {
                        props.onSelectedTabChanged?.(tab);
                        return tab;
                    });
                }}
                tabs={[
                    { id: "notes1", label: "Notes 1" },
                    { id: "notes2", label: "Notes 2" },
                    { id: "notes3", label: "Notes 3" },
                ]}
            />
            {selectedNotesTab === "notes1" && (
                <MultiLineTextField
                    placeholderText="Notes"
                    isEditable={props.isEditable}
                    value={props.characterData.notes[1]}
                    onStopEditing={(val) => {
                        props.onCharacterDataValueChanged?.([
                            { key: "notes_1", value: val },
                        ]);
                    }}
                    numberOfLines={notesLines}
                    numberOfEditLines={notesLines ?? 24}
                />
            )}
            {selectedNotesTab === "notes2" && (
                <MultiLineTextField
                    placeholderText="Notes"
                    isEditable={props.isEditable}
                    value={props.characterData.notes[2]}
                    onStopEditing={(val) => {
                        props.onCharacterDataValueChanged?.([
                            { key: "notes_2", value: val },
                        ]);
                    }}
                    numberOfLines={notesLines}
                    numberOfEditLines={notesLines ?? 24}
                />
            )}
            {selectedNotesTab === "notes3" && (
                <MultiLineTextField
                    placeholderText="Notes"
                    isEditable={props.isEditable}
                    value={props.characterData.notes[3]}
                    onStopEditing={(val) => {
                        props.onCharacterDataValueChanged?.([
                            { key: "notes_3", value: val },
                        ]);
                    }}
                    numberOfLines={notesLines}
                    numberOfEditLines={notesLines ?? 24}
                />
            )}
        </FlexColumn>
    );
}
